import React, { useEffect, useState } from "react";
import { supabase, getSession } from "../../services/Account/Supabase";
import { useNavigate } from "react-router-dom";

const Main: React.FC = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<{ name: string; email: string; username: string | null } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const setupSession = async () => {
      const session = await getSession();

      if (!session) {
        navigate("/login");
        return;
      }

      try {
        const { data, error } = await supabase
          .from("user")
          .select("username")
          .eq("uid", session.user.id)
          .single();

        if (error && error.code !== "PGRST116") {
          console.error("Error fetching user data:", error);
        }

        setUser({
          name: session.user.user_metadata?.name ?? "Guest",
          email: session.user.email ?? "No EMAIL",
          username: data?.username ?? null,
        });
      } catch (err) {
        console.error("Unexpected error:", err);
      } finally {
        setLoading(false);
      }
    };

    setupSession();
  }, [navigate]);

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error("Error logging out:", error.message);
    } else {
      navigate("/login");
    }
  };

  return (
    <div
      className="flex h-screen items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: "url('https://i.imgur.com/X0nlfMX.png')" }}
    >
      <div className="w-full max-w-md p-6 bg-white bg-opacity-80 backdrop-blur-lg rounded-lg shadow-md text-center">
        {loading || !user ? (
          <>
            <h1 className="text-2xl font-bold">Loading user information...</h1>
            <button onClick={handleLogout} className="mt-4 bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600">
              Logout
            </button>
          </>
        ) : user.username === null ? (
          <>
            <h1 className="text-2xl font-bold">Welcome!</h1>
            <p className="text-gray-600 mb-4">You need to choose a username to continue.</p>
            <button onClick={() => navigate("/choose-username")} className="w-full bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600">
              Choose Username
            </button>
            <button onClick={handleLogout} className="mt-4 w-full bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600">
              Logout
            </button>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold">Welcome, {user.username}!</h1>
            <p className="text-gray-600 mb-4">What would you like to do?</p>
            <button onClick={() => navigate("/rooms")} className="w-full bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600">
              Play Game
            </button>
            <button onClick={() => navigate("/arrange-board")} className="mt-4 w-full bg-yellow-500 text-white px-4 py-2 rounded-lg hover:bg-yellow-600">
              Arrange Board
            </button>
            <button onClick={handleLogout} className="mt-4 w-full bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600">
              Logout
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Main;
